<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24" >
            <a-form-item :label="$t('label.fileType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" disabled v-decorator="['archType',{'initialValue':'30'}]" :trigger-change="true" dictCode="dalx" :placeholder="$t('label.pleaseSelectTheTypeOfFile')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.inspectionSubcategoryCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheInspectionSubcategoryCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.descriptionOfInspectionSubcategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['name', validatorRules.name]" :placeholder="$t('label.pleaseEnterTheInspectionSubcategoryDescription')"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('name')" :popLists="getMainTablePop('name')">
                <a-input
                  v-decorator="['name']"
                  :read-only="whetherLang('name')"
                  @click="isLangClick('name', true)"
                  :placeholder="$t('label.pleaseEnterTheInspectionSubcategoryDescription')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.inspectionCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['categoryCode']" :trigger-change="true" dictCode="xjxfl" :placeholder="$t('label.pleaseSelectTheInspectionCategory')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.description')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['description']" placeholder="请输入说明描述"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('description')" :popLists="getMainTablePop('description')">
                <a-input
                  v-decorator="['description']"
                  :read-only="whetherLang('description')"
                  @click="isLangClick('description', false)"
                  :placeholder="$t('label.pleaseEnterADescription')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue':'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.inspectionItem')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :tableName="subTable[0]"
          :loading="efsMdInspectionItemTable.loading"
          :columns="efsMdInspectionItemTable.columns"
          :dataSource="efsMdInspectionItemTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue, validateDuplicateValueTwoCol } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsMdArchivesForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    data() {
      return {
        mainTable: 'efs_md_archives',
        subTable: ['efs_md_inspection_item'],
        isCodeDisabled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFileCode')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_archives', 'code', value,this.model.id, callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFileDescription')},
            ]
          },
        },
        refKeys: ['efsMdInspectionItem', ],
        tableKeys:['efsMdInspectionItem', ],
        activeKey: 'efsMdInspectionItem',
        // 巡检项
        efsMdInspectionItemTable: {
          loading: false,
          tableName: 'efs_md_inspection_item',
          dataSource: [],
          columns: [
            {
              title: this.$t('tableHeader.inspectionCode'),
              key: 'code',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.$t('tableHeader.inspectionItemDescription'),
              key: 'name',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
          ]
        },
        url: {
          add: "/inspectArchive/efsMdArchives/add",
          edit: "/inspectArchive/efsMdArchives/edit",
          queryById: "/inspectArchive/efsMdArchives/queryById",
          efsMdInspectionItem: {
            list: '/inspectArchive/efsMdArchives/queryEfsMdInspectionItemByMainId'
          },
        }
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.efsMdInspectionItemTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'archType','code','name','categoryCode','description','validFlag')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.isCodeDisabled = true;
          this.requestSubTableData(this.url.efsMdInspectionItem.list, params, this.efsMdInspectionItemTable)
        }else{
          this.isCodeDisabled = false;
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          efsMdInspectionItemList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'archType','code','name','categoryCode','description','validFlag'))
     },

    }
  }
</script>

<style scoped>
</style>